(function () {
	"use strict";
	let blockwheelsBlocksSlider = {
		initAll: function () {

			let heroSlider = document.querySelectorAll(
				".blockwheels-hero-slider-container .splide"
			);
			this.splideSlider(heroSlider);
		},
		splideSlider: function (elementList) {
			if (!elementList || elementList.length === 0) {
				return;
			}

			for (let i = 0; i < elementList.length; i++) {
				let thisSlider = elementList[i];
				if (!thisSlider || !thisSlider.children || thisSlider.classList.contains('is-initialized')) {
					continue;
				}

				let parsedData = thisSlider.dataset;

				// Add this to remove slick based css from hiding dataSet
				thisSlider.classList.add("splide-initialized");
				thisSlider.classList.add("splide-slider");

				let splideSlider = new Splide(thisSlider, {
					type        : 'slide',
					rewind		: true,
					focus       : 0,
					pagination	: ( parsedData.pagination === 'true' ) ? true : false,
					arrows		: ( parsedData.arrows === 'true' ) ? true : false,
					drag     	: ( parsedData.drag === 'true' ) ? true : false,
					autoplay    : ( parsedData.autoplay === 'true' ) ? true : false,
					interval    : parsedData.interval,
					speed       : parsedData.speed,
					perPage		: parsedData.lgCol,
					gap    		: parsedData.lgGap,
					breakpoints: {
						1200: {
							perPage	: parsedData.mdCol,
							gap    	: parsedData.mdGap,
						},
						640: {
							perPage	: parsedData.smCol,
							gap    	: parsedData.smGap,
						},
					},
				});
				splideSlider.mount();
			}
		},

		// Initiate the menus when the DOM loads.
		init: function () {
			blockwheelsBlocksSlider.initAll();
		},
	};
	if (document.readyState === "loading") {
		// The DOM has not yet been loaded.
		document.addEventListener("DOMContentLoaded", blockwheelsBlocksSlider.init);
	} else {
		// The DOM has already been loaded.
		blockwheelsBlocksSlider.init();
	}
})();